<template>
  <div class="apply-text">
    <p class="apply-icp">{{ initProjectList.site_info.icp }}</p>
    <p class="apply-icp" v-html="initProjectList.site_info.address"></p>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
    }),
  },
};
</script>

<style scoped>
.apply-text {
  width: 100%;
  padding: 10px;
}
.apply-text p {
  padding-bottom: 5px;
}
</style>
